module.exports = __webpack_public_path__ + "img/logoOrange.0df5748c.svg";